export default {
	state: {
		pmFundingBalances: []
	},

	actions: {
		getPmFundingBalances(actionContext) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					var profile = actionContext.rootState.Profile.profile

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/GetPmFundingBalances?userid=${profile.userid}`)
						.then(response => {
							var records = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data)

							actionContext.commit("setPmFundingBalances", records)
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		}
	},

	mutations: {
		setPmFundingBalances(state, pmFundingBalances) {
			state.pmFundingBalances = pmFundingBalances.map(x => {
				x.total = x.total.replace(/[^\w\s.]/gi, '')
				x.percent = x.balance / x.total

				return x
			})
		}
	},

	namespaced: true
}